import { WindowMetaData } from '../../../types';

const ANONYMOUS_ID = '0';
const ANONYMOUS_ROLE = 'anonymous user';

/**
 * Drupal injects window.metaData.user on every page. A visitor who is not signed in gets
 * id "0" and the single role "anonymous user" (the other fields are empty or null). A page without
 * window.metaData (a host that is not Drupal) has no signed-in member either, so it counts too.
 */
export function isDrupalAnonymousUser(user: Partial<WindowMetaData['user']> | null | undefined): boolean {
  if (!user) return true;

  return user.id === ANONYMOUS_ID || (user.roles || []).includes(ANONYMOUS_ROLE);
}
